<div class="p-4 bg-white">
  @if (!selectedAgent) {
    <div class="mb-3 p-3 border-round surface-300 border-orange-300 border-1 text-orange-800">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'chat.input.select-agent-message' | translate }}</span>
      </div>
    </div>
  }

  <div class="flex gap-3 align-items-end mt-3 mb-3">
    <textarea
      #messageInputElement
      [(ngModel)]="messageInput"
      (keydown.enter)="handleEnterKey($event)"
      [placeholder]="'chat.input.message-placeholder' | translate"
      [rows]="3"
      class="flex-1"
      pInputTextarea
      [autoResize]="true">
    </textarea>

    <p-button
      (onClick)="sendMessage()"
      [disabled]="!messageInput.trim() || !selectedAgent || isProcessing"
      [icon]="isProcessing ? 'pi pi-spin pi-spinner' : 'pi pi-send'"
      [label]="isProcessing ? ('chat.input.sending' | translate) : ('chat.input.send' | translate)"
      [class]="isProcessing ? 'p-button-success' : 'p-button-primary'"
      class="white-space-nowrap">
    </p-button>
  </div>

  @if (showContextTip && (!contextData || contextData.trim() === '')) {
    <div class="mt-3 p-3 border-round surface-100 border-primary-300 border-1 text-primary-700">
      <div class="flex justify-content-between align-items-center w-full">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-info-circle"></i>
          <span>{{ 'chat.input.context-tip' | translate }}</span>
        </div>
        <button
          type="button"
          class="p-link text-primary-700 hover:text-primary-800"
          (click)="dismissContextTip()"
          style="background: none; border: none; padding: 4px; margin: 0;">
          <i class="pi pi-times" style="font-size: 0.8rem;"></i>
        </button>
      </div>
    </div>
  }
</div>
